import { render, staticRenderFns } from "./SectionScoringGroup.vue?vue&type=template&id=52a90e11&scoped=true"
import script from "./SectionScoringGroup.vue?vue&type=script&lang=js"
export * from "./SectionScoringGroup.vue?vue&type=script&lang=js"
import style0 from "./SectionScoringGroup.vue?vue&type=style&index=0&id=52a90e11&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a90e11",
  null
  
)

export default component.exports